/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Quick_Actions_AriaInputs */

const es_nav_quick_actions_aria = /** @type {(inputs: Nav_Quick_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones rápidas`)
};

const gl_nav_quick_actions_aria = /** @type {(inputs: Nav_Quick_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accións rápidas`)
};

const en_nav_quick_actions_aria = /** @type {(inputs: Nav_Quick_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick actions`)
};

/**
* | output |
* | --- |
* | "Quick actions" |
*
* @param {Nav_Quick_Actions_AriaInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_quick_actions_aria = /** @type {((inputs?: Nav_Quick_Actions_AriaInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Quick_Actions_AriaInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_quick_actions_aria(inputs)
	if (locale === "en") return en_nav_quick_actions_aria(inputs)
	return es_nav_quick_actions_aria(inputs)
});